import axios from "axios";
import { API_HOST } from "@/core/variables";

class AuthRepository {
    logout = () => {
        return axios.post(`${API_HOST}/auth/logout`);
    };

    getProfile = () => {
        return axios.get(`${API_HOST}/auth/me`);
    };
}

const authRepository = new AuthRepository();

export default authRepository;
